// Shared status chips for the screening response views (production + lab).
// Each badge carries an icon alongside its label so state is never conveyed by
// colour alone — the amber/green chips sit below 3:1 on a white surface.
import React from "react";
import { CheckCircle2, XCircle, Clock, Phone } from "lucide-react";

export const intentBadge = (intent) => {
    switch (intent) {
        case "interested":
            return { text: "Interested", cls: "bg-green-50 text-green-600 border-green-200", Icon: CheckCircle2 };
        case "not_interested":
            return { text: "Not interested", cls: "bg-red-50 text-red-500 border-red-200", Icon: XCircle };
        default:
            return { text: "Awaiting", cls: "bg-gray-50 text-gray-500 border-gray-200", Icon: Clock };
    }
};

// Binary verdict; null when there was nothing to evaluate (no gates configured).
export const qualifiedBadge = (qualified) => {
    if (qualified === true) return { text: "Qualified", cls: "bg-green-50 text-green-600 border-green-200", Icon: CheckCircle2 };
    if (qualified === false) return { text: "Not qualified", cls: "bg-amber-50 text-amber-600 border-amber-200", Icon: XCircle };
    return null;
};

// Surfaced only for calls — email/WhatsApp link-clicks have no definitive channel.
export const channelBadge = (channel) =>
    channel === "call" ? { text: "Call", cls: "bg-blue-50 text-blue-600 border-blue-200", Icon: Phone } : null;

export const StatusChip = ({ badge, className = "" }) => {
    if (!badge) return null;
    const { text, cls, Icon } = badge;
    return (
        <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium border whitespace-nowrap ${cls} ${className}`}>
            {Icon && <Icon className="w-3.5 h-3.5 shrink-0" />}
            {text}
        </span>
    );
};

export const LinkedInLink = ({ url, className = "w-3.5 h-3.5" }) =>
    url ? (
        <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-300 hover:text-blue-700 shrink-0">
            <svg className={className} fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
        </a>
    ) : null;
